export enum DashboardActivationPopupsMetric {
  DISPLAY_COUNT = "popup_display_count",
  REGAIN_SCV = "regain_scv"
}

export enum DashboardMailsMetric {
  MAILS_SENT = "mails_sent",
  REGAIN_SCV = "regain_scv"
}

export enum DashboardNewsletterFormsMetric {
  SUBSCRIPTIONS_COUNT = "subscriptions_count",
  REGAIN_SCV = "regain_scv"
}
